import Vue from "vue";
import Vuetify from "vuetify/lib";
import { appIdentifier } from "@/utils/appIdentifier.js";
Vue.use(Vuetify);

//import theme
import * as themes from "@/styles/themes.js";
const theme = themes[appIdentifier()];

export default new Vuetify({
  theme: {
    options: {
      //this creates css variables to use ex: var(--v-primary-base)
      customProperties: true
    },
    themes: {
      light: { ...theme }
    }
  }
});
